import React from 'react';
import styles from './Pagination.module.scss';
import cn from 'classnames';
import PaginationArrow from '../../../../Icons/PaginationArrow';

export default function Pagination({ totalPages, currentPage, onPageChange, fields }) {
  const handlePrev = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  const handlePageClick = (page) => {
    if (page !== currentPage) onPageChange(page);
  };

  return (
    <div className={styles.wrapper}>
      <button
        className={cn(styles.prevNext, currentPage === 1 && styles.prevNext_disabled)}
        onClick={handlePrev}
      >
        <PaginationArrow />
        {fields?.backButtonText?.value || 'Back'}
      </button>
      {Array.from({ length: totalPages }).map((_, index) => {
        const page = index + 1;
        return (
          <button
            key={page}
            className={cn(styles.button, currentPage === page && styles.button_active)}
            onClick={() => handlePageClick(page)}
          >
            {page}
          </button>
        );
      })}
      <button
        className={cn(styles.prevNext, currentPage === totalPages && styles.prevNext_disabled)}
        onClick={handleNext}
      >
        {fields?.nextButtonText?.value || 'Next'} <PaginationArrow isRotated={true} />
      </button>
    </div>
  );
}
